
import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator'
import {
  HomeOffer, MobileOffer,
  createTranslatedOfferBenefitsInstance,
  TranslatableContext,
  createAmpTranslatedOfferDetailsInstance,
} from '@alao-frontend/core'

import SimpleOfferCardLayout from './SimpleOfferCardLayout.vue'
import SimpleOfferCardDetails from './SimpleOfferCardDetails.vue'
import SimpleOfferCardPrice from './SimpleOfferCardPrice.vue'

import type { Theme } from '~/types/theme'

import { checkDateLessDays } from '~/utils/check-date-less-days'

import type { AdditionalQueryParams } from '~/core/osp/additional-query-params'
import { plainObjectToRouteQueryObject } from '~/core/osp/additional-query-params'
import { getExternalCompareMobileSlugHref, getExternalCompareHomeSlugHref } from '~/utils/external-links.utils'

@Component({
  components: {
    SimpleOfferCardLayout,
    SimpleOfferCardDetails,
    SimpleOfferCardPrice,
  },
})
export default class SimpleOfferCard extends Vue {
  @Prop({ required: true, type: Object })
  readonly offer!: HomeOffer | MobileOffer

  @Prop({
    required: false,
    default: 'light',
    type: String,
  })
  readonly theme!: Theme

  @Prop({ required: false, type: Object, default: () => ({}) })
  readonly additionalParams!: AdditionalQueryParams

  protected readonly details = createAmpTranslatedOfferDetailsInstance(
    this.offer,
    this.$i18n as TranslatableContext,
  )

  protected readonly benefits = createTranslatedOfferBenefitsInstance(
    this.offer,
    this.$i18n as TranslatableContext,
  )

  protected checkDateLessDays = checkDateLessDays

  get endDateInFewDays () {
    if (!this.offer.endDate) {
      return this.offer.endDate
    }

    return checkDateLessDays(this.offer.endDate) ? this.offer.endDate : null
  }

  get url () {
    const additionalParams = plainObjectToRouteQueryObject(this.additionalParams)

    // Формируем внешнюю ссылку в зависимости от типа предложения
    let externalUrl: string
    if (this.offer.constructor.name === 'MobileOffer') {
      externalUrl = getExternalCompareMobileSlugHref(this.$config.BASE_URL, this.localePath, this.offer.slug)
    } else {
      externalUrl = getExternalCompareHomeSlugHref(this.$config.BASE_URL, this.localePath, this.offer.slug)
    }

    // Добавляем дополнительные параметры к URL
    if (Object.keys(additionalParams).length > 0) {
      const queryString = new URLSearchParams(additionalParams as Record<string, string>).toString()
      externalUrl += `?${queryString}`
    }

    return externalUrl
  }

  @Emit('click')
  onClick () {
    return true
  }
}
